import $                 from 'jquery';
import React             from 'react';
import ReactDOM          from 'react-dom';
import Question          from './form-components/question';
import SubmitButton      from './form-components/submit-button';
import ErrorMessages     from './error-messages';
import ApiActionsFactory from './api/actions-factory';
import Handlebars        from 'handlebars';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    //console.log(this.props.questionnaire)
    this.ApiActions = ApiActionsFactory.get(`${this.props.questionnaire.qid}-${this.props.questionnaire.formId}`);
  }
  componentDidMount() {
    // let $this = $(ReactDOM.findDOMNode(this));
  }
  componentWillUpdate(nextProps,nextState) { }
  getQuestions() {
    const answered = this.props.questionnaire.questions.find( (question) => {
        return question.answered;
    })
    let questions = this.props.questionnaire.questions.sort((questionA, questionB)=>{
        return questionA.displayOrder - questionB.displayOrder;
    });
    if(answered) {
      questions.forEach( (question)=>{
          question.answered = true;
      })
    }
    return questions.map( (question,index) => {
      if(answered && !question.answered) {
        return;
      }
      let CountData = {
        counter: index+1
      }
      let template = Handlebars.compile(this.props.questionNumberText);
      let componentProps = {
        key: "question-"+question.questionId,
        question: question,
        flagRequired: this.props.flagRequired,
        questionNumberText: template(CountData),
        index: this.props.showQuestionNumber ? index+1 : -1
       }
      return (<Question {...componentProps} />);
    });
  }
  getCta() {
    let questions = this.props.questionnaire.questions;
    let answered = questions.find( (question) => {
      return question.answered;
    });
    //if(answered && (answered.poll || this.props.questionnaire.formType!="EVAL")) return;
    if(answered) {
      return;
    }
    return (
      <fieldset className="button-container">
        <SubmitButton questionnaire={this.props.questionnaire} configId={this.props.configId}/>
      </fieldset>
    )
  }
  render() {
    let questions = this.getQuestions();
    if(questions.length==0) return false;
    let cta = this.getCta();
    let formProps = {
      method: "post",
      onSubmit: (e) => {
        e.preventDefault();
        this.ApiActions.post(this.props.questionnaire);
      }
    }
    return(
      <form {...formProps}>
        <div className="questions-list">
        { questions }
        </div>
        { cta }
        <div className="error-messages-container">
        <ErrorMessages />
        </div>
      </form>
    )
  }
}
Form.propTypes={
  questionnaire: React.PropTypes.object.isRequired,
  questionNumberText: React.PropTypes.string,
  flagRequired: React.PropTypes.bool
}
Form.defaultProps={
  questionNumberText: '',
  flagRequired: false
}



// WEBPACK FOOTER //
// ./medscape_modules/qna/form.jsx